<script>
import categoriasNutricionalesQuicktable from './categoriasnutricionales/quicktable.vue'
import elementosNutricionalesQuicktable from './elementosnutricionales/quicktable.vue'
import navegacion from './elements/Navegacion.vue'
export default {
    name: 'CatalogosGeneral',
    components: { categoriasNutricionalesQuicktable, elementosNutricionalesQuicktable, navegacion },
    methods: {
        catLoaded() {
            if (!!this.$refs && !!this.$refs.nutricionales) {
                this.$refs.nutricionales.refresh()
            }
        }
    }
}
</script>

<template>
    <div id="CatalogosGeneral">
        <navegacion class="mb-4"/>
        <!-- As a link -->
        <b-row id="CatalogosGeneral">
            <b-col md="7">
                <elementos-nutricionales-quicktable header="Elementos nutricionales" ref="nutricionales" />
            </b-col>
            <b-col md="5">
                <categorias-nutricionales-quicktable header="Categorias" @loadedUp="catLoaded" />
            </b-col>
        </b-row>
    </div>
</template>